import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import OrdenPagoWizard from "./OrdenPagoWizard";
import { esRecargaPagina, medioPagoInicial, previewTieneResumen } from "./utils";
import moment from "moment";

const buildEstadoDesdeLocation = (state) => {
  const {
    cuitConsultado,
    comprobantesPayload,
    comprobantesDetalle,
    preview,
    idEmpresaSeleccionada,
    nombreEmpresaSeleccionada,
  } = state;

  const rowSelection = {};
  const importesAPagar = {};
  comprobantesPayload.forEach((c) => {
    const id = String(c.idcomprobante);
    rowSelection[id] = true;
    importesAPagar[id] = c.importe_a_pagar;
  });

  const idEmpresa =
    idEmpresaSeleccionada ??
    comprobantesDetalle?.[0]?.id_empresa ??
    null;
  const nombreEmpresa =
    nombreEmpresaSeleccionada ??
    comprobantesDetalle?.[0]?.nombre_empresa ??
    "";

  return {
    cuitConsultado,
    preview,
    rowSelection,
    importesAPagar,
    idEmpresaSeleccionada: idEmpresa,
    nombreEmpresaSeleccionada: nombreEmpresa,
    resultado: {
      cuit_normalizado: cuitConsultado,
      razon_social: preview?.proveedor?.razon_social,
      documentos: comprobantesDetalle ?? [],
      resumen: preview?.resumen,
    },
    medioPago: medioPagoInicial(moment()),
  };
};

const estadoNavegacionValido = (state) =>
  Boolean(
    state?.cuitConsultado &&
      state?.comprobantesPayload?.length &&
      previewTieneResumen(state?.preview)
  );

const OrdenPagoProveedor = () => {
  const location = useLocation();
  const state = location.state;

  if (esRecargaPagina() || !estadoNavegacionValido(state)) {
    return <Navigate to="/pago_proveedores" replace />;
  }

  return (
    <OrdenPagoWizard
      initialStep={2}
      estadoInicial={buildEstadoDesdeLocation(state)}
    />
  );
};

export default OrdenPagoProveedor;
